/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'clsx';

import styles from './chat-bubble.scss';

/**
 * This is the ChatBubble component class.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const ChatBubble = ({
  is_user_message,
  is_mine,
  author_fullname,
  date_pretty,
  message_text,
  ack_label,
}) => (
  <article
    className={classNames(styles.wrapper, {
      [styles.adminMessage]: !is_user_message,
      [styles.rightAlign]: !is_user_message || is_mine,
    })}
  >
    <div className={styles.message}>
      <p className={styles.header}>{author_fullname} · {date_pretty}</p>
      <div className={styles.text}>{message_text}</div>
      {ack_label && <div className={styles.label}>{ack_label}</div>}
    </div> 
  </article>
);

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
ChatBubble.propTypes = {
  is_mine: bool.isRequired,
  is_user_message: bool.isRequired,
  author_fullname: string.isRequired,
  message_text: string.isRequired,
  date_pretty: string.isRequired,
  ack_label: string,
};

/**
 * Declare default props.
 *
 * @type {Object}
 */
ChatBubble.defaultProps = {
  is_mine: false,
  ack_label: null,
};

export default ChatBubble;
